module.exports = __webpack_public_path__ + "img/4-gaz-boiler.92132b73.svg";